export default "__VITE_ASSET__Llvjj$ruQldKNA28Pdwz$w__"